import router from '../router/index'
import { createApp, inject, h } from 'vue'
import { setCommonApp } from '../utils/setCommonApp'
import { Modal, Button as IViewButton } from 'view-ui-plus'

const noop = () => {}
const sizes = {
  small: 320,
  middle: 480,
  large: 720
}
function modal(options) {
  const {
    width,
    title = '',
    size = 'default',
    render,
    component,
    okText = '确定',
    cancelText = '取消',
    className = 'ivu-modal-center',
    maskClosable = false,
    closable = true,
    scrollable = false,
    fullscreen = false,
    draggable = false,
    footerHide = false,
    styles = {},
    zIndex
  } = options
  const props = {
    title,
    width,
    closable,
    modelValue: true,
    maskClosable,
    scrollable,
    fullscreen,
    draggable,
    footerHide,
    styles,
    className,
    'z-index': zIndex
  }
  const container = document.createElement('div')
  document.body.appendChild(container)
  const instance = createApp({
    name: 'BizModal',
    router,
    data: () => {
      return {
        loading: false,
        visible: true,
        disabled: false,
        width: width === undefined ? sizes[size] || sizes.default : width,
        title
      }
    },
    created() {
      this.visible = true
    },
    methods: {
      onOk(data) {
        options.onOk && options.onOk(data)
        this.destroy()
      },
      onCancel() {
        options.onCancel && options.onCancel()
        this.destroy()
      },
      destroy() {
        this.loading = false
        this.visible = false
        instance.unmount()
        document.body.contains(container) && document.body.removeChild(container)
      }
    },
    render() {
      const btns = options.buttons || [
        {
          id: 'ok',
          name: okText,
          type: 'primary'
        },
        {
          id: 'cancel',
          name: cancelText,
          type: 'primary'
        }
      ]
      return h(
        Modal,
        {
          ...props,
          onOnVisibleChange: show => {
            if (!show) {
              this.onCancel()
            }
          },
          onOnCancel: this.onCancel,
          onOnOk: this.onOk
        },
        {
          default: props =>
            component === undefined
              ? render(h)
              : h(component, {
                  ref: 'body',
                  ...options.props,
                  onDisabled: val => {
                    this.disabled = !!val
                  },
                  onCancel: this.onCancel,
                  onOk: this.onOk,
                  // vue3 backup，both are working as 'ok' ans 'on-ok
                  onOnCancel: this.onCancel,
                  onOnOk: this.onOk
                }),
          footer: props =>
            h(
              'div',
              {
                style: {
                  textAlign: 'right'
                }
              },
              btns.map(item => {
                return h(
                  IViewButton,
                  {
                    type: item.type,
                    size: item.size || size,
                    ghost: item.id === 'cancel' || item.ghost,
                    disabled: item.id === 'ok' ? this.disabled : false,
                    loading: item.id === 'ok' ? this.loading : false,
                    class: {
                      group: btns.length > 1
                    },
                    onClick: () => {
                      const { id } = item || {}
                      const name = `on${id[0].toUpperCase()}${id.substr(1)}`
                      if (id === 'ok' && this.$refs.body && this.$refs.body.confirm) {
                        this.loading = true
                        const func = this.$refs.body.confirm()
                        if (func.then) {
                          return func
                            .then(data => (options.onOk ? options.onOk(data) : noop()))
                            .then(() => this.destroy())
                            .catch(() => {
                              this.loading = false
                            })
                        } else {
                          options.onOk ? options.onOk(func) : noop()
                          this.destroy()
                          return
                        }
                      }
                      const callback = (options[name] || noop)()
                      if (!callback || !callback.then) {
                        return this.destroy()
                      }
                      this.loading = true
                      callback
                        .then(() => this.destroy())
                        .catch(() => {
                          this.loading = false
                        })
                    }
                  },
                  {
                    default: () => item.name
                  }
                )
              })
            )
        }
      )
    }
  })
  setCommonApp(instance)

  instance.mount(container)
  return instance
}
function open(options) {
  return modal(options)
}
function alert(options) {
  const contentRender = h => h('div', options.content || '')
  const render = options.render || contentRender
  return modal({
    ...options,
    render,
    buttons: [
      {
        id: 'ok',
        name: options.okText || '确定',
        type: 'primary'
      }
    ]
  })
}
function confirm(options) {
  const contentRender = h => h('div', options.content || '')
  const render = options.render || contentRender
  return modal({
    ...options,
    render
  })
}
const $modal = {
  open,
  alert,
  confirm
}
export const modalPlugin = {
  install: (app, options) => {
    app.provide('BizModal', $modal)
    app.config.globalProperties.$modal = $modal
  }
}
// 选项式用this.$modal.open，组合式用usePluginModal().open
export const usePluginModal = () => {
  return $modal
}
